<template>
  <v-form ref="form" @submit.prevent="submitForm" class="text-center">
    <v-text-field
      v-model="token"
      label="Personal access token"
      required
      :rules="[UUIDFormat]"
      @input="checkFormValidity"
    ></v-text-field>
    <v-btn
      class="mt-5 white--text"
      type="submit"
      color="#4d51c5"
      rounded
      :disabled="isDisabled"
      block
    >
      Save personal access token
    </v-btn>
  </v-form>
</template>
<script>
export default {
  data: function () {
    return {
      token: "",
      isDisabled: true,
      UUIDFormat: (v) =>
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
          v
        ) || "Invalid UUID format",
    };
  },
  methods: {
    submitForm: function () {
      this.$emit("submitPersonalToken", this.token);
    },
    checkFormValidity() {
      if (this.$refs.form.validate()) this.isDisabled = false;
      else this.isDisabled = true;
    },
  },
};
</script>
